import { useEffect } from 'react';
import PropTypes from 'prop-types';

import Component from '@plone/volto/components/theme/Component/Component';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import cx from 'classnames';
import DefaultSummary from '@kitconcept/volto-light-theme/components/Summary/DefaultSummary';
import { useDispatch, useSelector } from 'react-redux';
import { loadTaxonomy } from '../../../actions';
import { FormattedMessage } from 'react-intl';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

const SummaryTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  const dispatch = useDispatch();

  const taxonomies = useSelector((state) => state.taxonomies);

  useEffect(() => {
    const taxos = [
      'collective.taxonomy.classification',
      'collective.taxonomy.membership_type',
      'collective.taxonomy.person_type',
      'collective.taxonomy.employment_type',
      'collective.taxonomy.project_type',
      'collective.taxonomy.event_type',
    ];
    taxos.forEach((name) => {
      if (!taxonomies?.[name]?.loaded) {
        dispatch(loadTaxonomy(name));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  return (
    <>
      <div className="items">
        {items.map((item) => {
          const CustomItemBodyTemplate = config.getComponent({
            name: 'SummaryListingItemTemplate',
            dependencies: [item['@type']],
          }).component;
          const Summary =
            config.getComponent({
              name: 'Summary',
              dependencies: [item['@type']],
            }).component || DefaultSummary;

          const ItemBodyTemplate = () =>
            CustomItemBodyTemplate ? (
              <CustomItemBodyTemplate item={item} isEditMode={isEditMode} />
            ) : (
              <>
                <div className="listing-body">
                  <Summary
                    item={item}
                    HeadingTag="h3"
                    hide_description={
                      !item.Description ||
                      (item.Description && item.Description.trim() === '')
                    }
                  />
                  <ConditionalLink
                    item={item}
                    condition={!isEditMode}
                    className="listing-readmore"
                  >
                    <FormattedMessage
                      id="listing.readmore.more"
                      defaultMessage="Mehr"
                    />
                  </ConditionalLink>
                </div>
                <Component componentName="PreviewImage" item={item} alt="" />
              </>
            );
          return (
            <div
              className={cx(
                'listing-item',
                item['@type'].replace('saw.persons.', ''),
                item?.taxonomy_person_type?.[0] &&
                  `person-type-${item.taxonomy_person_type[0]}`,
              )}
              key={item['@id']}
            >
              <ItemBodyTemplate item={item} isEditMode={isEditMode} />
            </div>
          );
        })}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

SummaryTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default SummaryTemplate;
